export enum AblyGoodsCardActionType {
  Like = 'LIKE',
}
